import { makeObservable, observable, action, runInAction } from "mobx";
import OpsAnalyticsDashboardAPI from "../api/OpsAnalyticsDashboardAPI";
import { OpsAnalyticsData } from "../models/Dashboard/OpsDashboard/OpsAnalytics";
import { OpsAnalyticsAPIFilters } from "../models/Dashboard/OpsDashboard/OpsAnalyticsFilters";
import { LabelValue } from "../models/Dashboard/Analytics";
import dayjs from "dayjs";

export class OpsSourcingAnalyticsDashboardStore {
  analyticsAPI: OpsAnalyticsDashboardAPI;
  response: OpsAnalyticsData | null;
  pr_tats: LabelValue[];
  po_tats: LabelValue[];
  report: any[] | null;

  constructor() {
    this.analyticsAPI = new OpsAnalyticsDashboardAPI();
    this.response = {} as OpsAnalyticsData;
    this.pr_tats = [];
    this.po_tats = [];
    this.report = null;

    makeObservable(this, {
      response: observable,
      pr_tats: observable,
      po_tats: observable,
      report: observable,
      getAllAnalyticsData: action,
      _getPrTATs: action,
      getReportData: action,
    });
  }

  getReportData = async (url: string, filters: any) => {
    try {
      this.report = await this.analyticsAPI.getReportData(url, filters);
    } catch (error) {
      console.error("Error fetching Data", error);
      this.report = [];
    }
  };

  getAllAnalyticsData = async (filters: OpsAnalyticsAPIFilters) => {
    try {
      await Promise.all([this._getPrTATs(filters), this._getPoTATs(filters)]);
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  _getPrTATs = async (filters: OpsAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getOpsAnalyticsData(
        "/sourcing/tats",
        filters
      )) as LabelValue[];
      this.pr_tats = data;
    } catch (error) {
      throw error;
    }
  };

  _getPoTATs = async (filters: OpsAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getOpsAnalyticsData(
        "/sourcing/tats/po",
        filters
      )) as LabelValue[];
      if (data.length === 0) {
        this.po_tats = [];
      } else {
        this.po_tats = data;
      }
    } catch (error) {
      throw error;
    }
  };
}
